export const GET_CLASSIFIER_CONFIG = "admin/classifierConfig";

export const UPDATE_CLASSIFIER_CONFIG = "admin/classifierConfig";
